import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  LinearProgress,
  Typography,
  makeStyles,
  colors,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemIcon
} from '@material-ui/core';
import HealingIcon from '@material-ui/icons/Healing';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%'
  },
  avatar: {
    backgroundColor: colors.orange[600],
    height: 50,
    width: 50
  },
  differenceIcon: {
    color: colors.red[900]
  },
  differenceValue: {
    color: colors.red[900],
    marginRight: theme.spacing(1)
  }
}));

const PainReport = ({ className, ...rest }) => {
  const classes = useStyles();

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
          spacing={3}
        >
          <Grid item xs={1} style={{marginRight: 30}}>
            <Avatar className={classes.avatar}><HealingIcon /></Avatar>
          </Grid>
          <Grid item xs={10}>
            <Typography
              style={{color: "#002D55", marginBottom: 5}}
              variant="h5"
            >
              PAIN
            </Typography>
            <Typography
              style={{marginTop: 5, marginBottom: 5}}
              color="textSecondary"
              gutterBottom
              variant="h7"
            >
              See how your pain intensity on a scale from 1-100 developed over time at rest, with daily activities and with sport activities if relevant in your case. <br /><br />
              Track how often you experience your symptoms per week (frequency) and how long your symptoms last (duration). 
            </Typography>
            <Box
          mt={2}
          display="flex"
          alignItems="center"   
        >
        <Grid container direction="column" style={{marginRight: 40}}>
            <Grid item alignItems="left">
                <ListItem>
                  <ListItemText className={classes.differenceValue}
                    variant="body2" secondary="16%">
                  </ListItemText>
                  <ListItemIcon>
                    <ArrowDownwardIcon />
                  </ListItemIcon>
                  
                  <ListItemText
                    primary="Pain intensity level from 1-100 with rest. "/>
                  
                </ListItem>
                <ListItem>
                <ListItemText className={classes.differenceValue}
                    variant="body2" secondary="16%">
                  </ListItemText>
                  <ListItemIcon>
                    <ArrowDownwardIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Pain intensity level from 1-100 with daily activity. "
                  />
                </ListItem>
                <ListItem>
                <ListItemText className={classes.differenceValue}
                    variant="body2" secondary="16%">
                  </ListItemText>
                  <ListItemIcon>
                    <ArrowDownwardIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Pain intensity level from 1-100 with sport activity. "
                  />
                </ListItem>
                <ListItem>
                <ListItemText className={classes.differenceValue}
                    variant="body2" secondary="16%">
                  </ListItemText>
                  <ListItemIcon>
                    <ArrowDownwardIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Frequency of symptoms on weekly basis. "
                  />
                </ListItem>
            </Grid>
          </Grid>
        </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

PainReport.propTypes = {
  className: PropTypes.string
};

export default PainReport;